import { render, staticRenderFns } from "./Dimensions.vue?vue&type=template&id=811ea8a0&"
import script from "./Dimensions.vue?vue&type=script&lang=js&"
export * from "./Dimensions.vue?vue&type=script&lang=js&"
import style0 from "./Dimensions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSelect,QItem,QItemSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSelect,QItem,QItemSection})
